import { render } from "./Cohort.vue?vue&type=template&id=8d3338fc&scoped=true&ts=true"
import script from "./Cohort.vue?vue&type=script&lang=ts"
export * from "./Cohort.vue?vue&type=script&lang=ts"

import "./Cohort.vue?vue&type=style&index=0&id=8d3338fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d3338fc"]])

export default __exports__